import { isAllowedDomain } from "./utils";

export const Is_Remove_SCVC_Columns = [2470318656715464]

export const getCoulmnsAPiAmazon = (
  field_name,
  field_key,
  field_type = 'any',
  field_display = '',
  field_condition = 0,
  sortParam = null,
  custom_table_source = '',
  excludeDaysLeftColumn = false
) => {
  const selectedProfile = JSON.parse(sessionStorage.getItem('selectedProfileId') || '{}') || {};
  const amazonProfileId = selectedProfile?.profileId;
  console.log("getCoulmnsAPiAmazon", { field_name, custom_table_source})
  return [
    ...(field_name === 'Advertised ASINs' ? [
      // { id: 19, column_type: 'active_view', label: 'Active', param: 'active_status', checked: true, isTargeting: 1 },
      // { id: 21, column_type: 'image_view', label: 'Image', param: 'image', checked: true },
      {
        additionalClass: 'cus_wid',
        column_type: 'image_view',
        label: field_name,
        param: field_key,
        field_type: field_type,
        field_display: field_display,
        checked: true,
        default: 1
      },
      // { id: 31, column_type: 'text_view', label: 'Product Title', param: 'product_title', checked: true },
    ] : []),
    ...(field_name != 'Targeting' && field_name != 'Ad Group Name' && field_name != 'Campaign Name' && field_name != 'Advertised ASINs' && field_condition != 1
      ? [
        {
          additionalClass: 'cus_wid',
          column_type: 'column_field',
          label: field_name,
          param: field_key,
          field_type: field_type,
          field_display: field_display,
          sortParam: sortParam,
          checked: true,
          default: 1
        }
      ]
      : []),
    ...(field_name == 'Targeting' || field_condition == 1
      ? [
        // { id: 19, column_type: 'active_view', label: 'Active', param: 'active_status', checked: true },
        {
          additionalClass: 'cus_wid col_fixed',
          column_type: 'column_field',
          label: field_name,
          param: field_key,
          field_type: field_type,
          field_display: field_display,
          checked: true,
          default: 1
        },
        { id: 23, column_type: 'target_type_view', label: 'Campaign Types', param: 'Types', checked: false, isTargeting: 1, default: 1 },
        { id: 24, column_type: 'match_type_view', label: 'Match Types', param: 'matchTypes', checked: false, isTargeting: 1, default: 1 },
        { id: 29, is_based_available: 1, column_type: 'percentage', label: 'IS %', param: 'searchTermImpressionShare', checked: false },
        { id: 30, is_based_available: 1, column_type: 'number', label: 'IR', param: 'searchTermImpressionRank', checked: true },
        // { id: 20, column_type: 'status_view', label: 'Status', param: 'status', checked: true },
        // { id: 21, column_type: 'sug_bid_view', label: 'Sug. Bid', param: 'sug_bid', checked: true },
        // { id: 22, column_type: 'bid_view', label: 'Bid', param: 'bid_amount', checked: true },
        // { id: 23, column_type: 'TOS_IS_budget_view', label: 'TOS IS%', param: 'TOS_IS_perc', checked: true }
      ]
      : []),
    ...(field_name == 'Search Term' || custom_table_source == 'search_term' || custom_table_source == 'targeting'  ? [
      { id: 29, is_based_available: 1, column_type: 'percentage', label: 'IS %', param: 'searchTermImpressionShare', checked: false },
      { id: 30, is_based_available: 1, column_type: 'number', label: 'IR', param: 'searchTermImpressionRank', checked: true },
    ] : []),
    ...(field_name == 'Campaign Name'
      ? [
        { id: 19, column_type: 'active_view', label: 'Active', param: 'active_status', checked: false, isTargeting: 1, default: 1 },
        {
          additionalClass: 'cus_wid col_fixed',
          column_type: 'column_field',
          label: field_name,
          param: field_key,
          field_type: field_type,
          field_display: field_display,
          checked: true,
          default: 1
        },
        { id: 21, column_type: 'status_view', label: 'Status', param: 'budgetStatus', checked: false, isTargeting: 1, default: 1 },
        { id: 22, column_type: 'start_date_view', label: 'Start Date', param: 'startDate', checked: false, isTargeting: 1, default: 1 },
        { id: 23, column_type: 'budget_view', label: 'Budget', param: 'budget_amount', checked: false, isTargeting: 1, default: 1 },
        { id: 24, column_type: 'TOS_IS_budget_change', label: 'TOS Plc. \nBid Adj %', param: 'TOS_IS_perc', checked: false, isTargeting: 1, default: 1 },
        { id: 25, column_type: 'PDP_IS_budget_change', label: 'PP Plc. \nBid Adj %', param: 'PDP_IS_perc', checked: false, isTargeting: 1, default: 1 },
        { id: 25, column_type: 'ROS_IS_budget_change', label: 'ROS Plc. \nBid Adj %', param: 'ROS_IS_perc', checked: false, isTargeting: 1, default: 1 }
      ]
      : []),
    ...(field_name == 'Ad Group Name'
      ? [
        { id: 19, column_type: 'active_view', label: 'Active', param: 'active_status', checked: false, isTargeting: 1,default: 1 },
        {
          additionalClass: 'col_fixed cus_wid',
          column_type: 'column_field',
          label: field_name,
          param: field_key,
          field_type: field_type,
          field_display: field_display,
          checked: true,
          default: 1
        },
        // { id: 21, column_type: 'status_view', label: 'Status', param: 'status', checked: true, isTargeting: 1 },
        // { id: 22, column_type: 'number', label: 'Total Targets', param: 'total_targets', checked: true, isTargeting: 1 },
        // { id: 23, column_type: 'number', label: 'Products', param: 'total_products', checked: true, isTargeting: 1 },
        // { id: 24, column_type: 'percentage', label: 'TOS IS%', param: 'tos_is_perc', checked: true, isTargeting: 1 }
      ]
      : []),
      // ...(field_name == 'Advertised ASINs' ? [{ id: 30, column_type: 'bsr_rank', additionalClass: 'bsr_column', label: 'BSR Rank', param: 'BSR_Orders', checked: true, default: 1 }]:[]),
    ...(field_name === 'Ad Group Name'
      ? [
    { id: 48, is_based_available: 1, column_type: 'text_view', label: 'Campaign Name', param: 'campaignName', prefix_sign: 'currency', checked: true , default: 1},
        ]
    : []),
    { id: 1, is_based_available: 1, column_type: 'number', label: 'Spend', param: 'Spend', prefix_sign: 'currency', checked: true },
    ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : field_name == 'Advertised ASINs' || custom_table_source === 'asin' || ['Date', 'Months', 'Weeks', 'Weekdays'].includes(field_name)
      ? [
        { id: 30, column_type: 'number', prefix_sign: 'currency', label: 'Total Revenue', param: 'Total_revenue', checked: true },
      ]
      : []),
    { id: 2, is_based_available: 1, column_type: 'number', label: 'Revenue', param: 'Revenue', prefix_sign: 'currency', checked: true },
    ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : (field_name === 'Advertised ASINs' || custom_table_source === 'asin')
    ? [
        { id: 31, column_type: 'number', prefix_sign: 'currency', label: 'Organic Revenue', param: 'Organic_revenue', checked: true },
        { id: 32, column_type: 'number', label: 'Inventory', param: 'Inventory', checked: true },
        { id: 33, column_type: 'number', label: 'Total Orders', param: 'Total_order', checked: true },
        { id: 34, column_type: 'number', label: 'Organic Orders', param: 'Organic_order', checked: true },
      ]
    : []),
    ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : ['Date', 'Months', 'Weeks', 'Weekdays'].includes(field_name) ? [
        { id: 31, column_type: 'number', prefix_sign: 'currency', label: 'Organic Revenue', param: 'Organic_revenue', checked: true },
        { id: 50, column_type: 'number', label: 'Total Orders', param: 'Total_order', checked: true },
        { id: 51, column_type: 'number', label: 'Organic Orders', param: 'Organic_order', checked: true },
        { id: 52, column_type: 'decimal', label: 'Total ROAS', param: 'TotalROAS', checked: false },
        { id: 53, column_type: 'percentage', label: 'Total ACOS %', param: 'TotalACOS', checked: true },
        { id: 54, column_type: 'decimal', label: 'Organic ROAS', param: 'OrganicROAS', checked: true },
        { id: 55, column_type: 'percentage', label: 'Organic ACOS %', param: 'OrganicACOS', checked: true }
      ]
    : []),
    { id: 3, is_based_available: 1, column_type: 'number', label: 'Orders', param: 'Orders', checked: true },
    { id: 4, is_based_available: 1, column_type: 'number', label: 'Impression', param: 'Impressions', checked: true },
    // ...(field_name == 'Targeting' || field_name == 'Campaign Name' ? [{ id: 31, is_based_available: 1, column_type: 'percentage', label: 'TOS IS %', param: 'TOIS_perc', checked: false }, ] : []),
    // ...(field_name == 'Search Term' ? [{ id: 25, is_based_available: 1, column_type: 'percentage', label: 'IS %', param: 'IS_perc', checked: true }, { id: 25, is_based_available: 1, column_type: 'percentage', label: 'API IS %', param: 'api_is_perc', checked: true }, { id: 25, is_based_available: 1, column_type: 'number', label: 'ST Rank', param: 'search_term_impression_rank', checked: true }] : []), //  Hidden per Hariom Comment in the hector plus whatsapp group
    // ...(field_name == 'Targeting' || field_name == 'Campaign Name' || field_name == 'Search Term' ? [{ id: 31, is_based_available: 1, column_type: 'percentage', label: 'Total Imp', param: 'Total_Impressions', checked: true }] : []),
    ...(field_name == 'Targeting' || field_name == 'Campaign Name' ? [{ id: 31, is_based_available: 1, column_type: 'percentage', label: 'API TOS IS %', param: 'api_tos_perc', checked: false }] : []),
    { id: 5, is_based_available: 1, column_type: 'number', label: 'Clicks', param: 'Clicks', checked: true },
    { id: 6, is_based_available: 1, column_type: 'decimal', label: 'CPA', param: 'CPA', prefix_sign: 'currency', checked: true },
    ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : (field_name == 'Advertised ASINs' || custom_table_source === 'asin')
      ? [
        { id: 33, is_based_available: 1, column_type: 'decimal', label: 'Total ROAS', param: 'TotalROAS', checked: false },
        //{ id: 34, is_based_available: 1, column_type: 'decimal', label: 'Organic ROAS', param: 'OrganicROAS', checked: true },
      ]
      : []),
    { id: 35, is_based_available: 1, column_type: 'decimal', label: 'Ad ROAS', param: 'ROAS', checked: true },
    { id: 8, is_based_available: 1, column_type: 'decimal', label: 'AOV', param: 'AOV', prefix_sign: 'currency', checked: true },
    { id: 9, is_based_available: 1, column_type: 'percentage', label: 'CTR %', param: 'CTR', checked: false },
    { id: 10, is_based_available: 1, column_type: 'decimal', label: 'CPM', param: 'CPM', checked: true },
    { id: 11, is_based_available: 1, column_type: 'decimal', label: 'CPC', param: 'CPC', checked: true },
    ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : (field_name == 'Advertised ASINs' || custom_table_source === 'asin')
      ? [
        { id: 36, is_based_available: 1, column_type: 'percentage', label: 'Total ACOS %', param: 'TotalACOS', checked: true },
        //{ id: 37, is_based_available: 1, column_type: 'percentage', label: 'Organic ACOS %', param: 'OrganicACOS', checked: true },
      ]
      : []),
    { id: 38, is_based_available: 1, column_type: 'percentage', label: 'Ad ACOS %', param: 'ACOS', checked: true },
    { id: 13, is_based_available: 1, column_type: 'number', label: 'RPC', param: 'RPC', checked: false },
    { id: 14, is_based_available: 1, column_type: 'number', label: 'CPO', param: 'CPO', checked: false },
    { id: 15, is_based_available: 1, column_type: 'percentage', label: 'Spend %', param: 'Spend_perc', checked: true },
    { id: 16, is_based_available: 1, column_type: 'percentage', label: 'Rev %', param: 'Revenue_perc', checked: true },
    { id: 17, is_based_available: 1, column_type: 'percentage', label: 'CR %', param: 'CR_perc', checked: true },
    { id: 18, is_based_available: 1, column_type: 'number', label: 'CC', param: 'CC', checked: true },
    ...((field_name == 'Campaign Name' || field_name == 'Ad Group Name' || field_name == 'Advertised ASINs' || field_name == 'Targeting' || field_name == 'Search Term' || field_name == 'Placement Types' || custom_table_source == 'campaigns' || custom_table_source == 'asin' || custom_table_source == 'search_term' || custom_table_source == 'targeting')
      ? [
        { id: 26, column_type: 'number', label: 'NTB Order', param: 'NTB_Orders', checked: false, },
        { id: 27, column_type: 'percentage', label: 'NTB Order %', param: 'percentage_of_Orders_NTB', checked: false,},
        { id: 28, column_type: 'number', prefix_sign: 'currency', label: 'NTB Sales', param: 'NTB_Sales', checked: false},
        { id: 29, column_type: 'percentage', label: 'NTB Sales %', param: 'percentage_of_sales_NTB', checked: false},
      ]
      : []),
      // ...(field_name == 'Advertised ASINs'
      // ? [
      //   { id: 30, column_type: 'number', prefix_sign: 'currency', label: 'Total \n Revenue', param: 'Total_revenue', checked: true, default: 1 },
      //   { id: 31, column_type: 'number', prefix_sign: 'currency', label: 'Organic \n Revenue', param: 'Organic_revenue', checked: true, default: 1 },
      //   { id: 32, column_type: 'number', label: 'Inventory', param: 'Inventory', checked: true, default: 1 },
      // ]
      // : []),
      ...((field_name == 'Advertised ASINs' || field_name == 'Targeting' || custom_table_source == 'asin' || custom_table_source == 'targeting')
      ? [
        { id: 39, is_based_available: 1, column_type: 'number', label: 'DPV', param: 'DPV', checked: false },
        { id: 40, is_based_available: 1, column_type: 'number', label: 'Viewable Impressions', param: 'Viewable_Impressions', checked: false },
        { id: 41, is_based_available: 1, column_type: 'number', label: 'Video First Quartile', param: 'Video_First_Quartile', checked: false },
        { id: 42, is_based_available: 1, column_type: 'number', label: 'Video Midpoint', param: 'Video_Midpoint', checked: false },
        { id: 43, is_based_available: 1, column_type: 'number', label: 'Video Third Quartile', param: 'Video_Third_Quartile', checked: false },
        { id: 44, is_based_available: 1, column_type: 'number', label: 'Video Complete', param: 'Video_Complete', checked: false },
        { id: 45, is_based_available: 1, column_type: 'number', label: 'Video Unmute', param: 'Video_Unmute', checked: false },
        { id: 46, is_based_available: 1, column_type: 'number', label: 'VTR', param: 'VTR', checked: false },
        { id: 47, is_based_available: 1, column_type: 'number', label: 'VCTR', param: 'VCTR', checked: false },
      ]
      : []),
    ...(field_name === 'Advertised ASINs' && !excludeDaysLeftColumn ? [
      { id: 56, column_type: 'number', label: 'Days Left', param: 'days_left', checked: true, default: 2, isLast: 1, ungroup: false},
    ] : []),
    { id: 19, is_based_available: 1, column_type: 'comparison', label: 'Compare', param: 'Compare', checked: false, isLast: 1 },
  ];
};

const selectedProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));

const defaultCacheSettings = {
  TargetingType: true,
}

const getCoulmnsAPiAmazonAccountSummary = (field_name, field_key, field_type = 'any', field_display = '', imageIsAvailable = '') => {
  return [
    {
      column_type: '',
      label: field_name,
      param: field_key,
      field_type: field_type,
      field_display: field_display,
      imageIsAvailable: imageIsAvailable
    }
  ];
};

const AMAZON_TAB_GROUP = {
  parent_tabs: [
    {
      id: 3,
      is_group: 0,
      title: 'Targeting',
      title_aggregate: 'targeting-summary',
      param_key: 'targeting-summary',
      heatMapEnabled: 1,
      url_update: '/targeting',
      prefer_tables: {
        // Targeting

        type: [
          {
            table_name: 'Campaign Types',
            classNames: 'text-capitalize',
            table_id: 'CampaignTypes',
            end_point: '/amazon/campaignTypeList',
            payload: {
              aggregate: 'CampaignType',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'CampaignType',
              data_id: 'Type',
              trend_chart: 'enable',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Campaign Types',
                field_key: 'Type',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },

          {
            table_name: 'Targeting Types',
            table_id: 'Targeting_types',
            end_point: '/amazon/targetingTypeList',
            payload: {
              aggregate: 'TargetingType',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'TargetingType',
              data_id: 'TargetingType',
              trend_chart: 'enable',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Targeting Types',
                field_key: 'TargetingType',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },

          {
            table_name: 'Sub Targeting Types',
            table_id: 'Sub_Targeting_types',
            end_point: '/amazon/subTargetingTypeList',
            payload: {
              aggregate: 'SubTargetingType',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'SubTargetingType',
              data_id: 'SubTargetingType',
              trend_chart: 'enable',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Sub Targeting Types',
                field_key: 'SubTargetingType',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },

          {
            table_name: 'Ad Formats',
            table_id: 'Ad_Formats',
            end_point: '/amazon/adFormatList',
            payload: {
              aggregate: 'AdFormat',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'AdFormat',
              data_id: 'AdFormat',
              trend_chart: 'enable',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Sub Targeting Types',
                field_key: 'SubTargetingType',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              columnSummary: {
                field_name: 'Ad Formats',
                field_key: 'AdFormat',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              rows: [],
              summary: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },

          {
            table_name: 'Portfolio Name',
            table_id: 'Portfolio_Name',
            end_point: '/amazon/portfolioList',
            payload: {
              aggregate: 'PortFolioName',
              summary: 'AdvertisedProduct'
            },
            show: 'no',
            table_json: {
              aggregate: 'PortFolioName',
              data_id: 'portFolioName',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Portfolio Name',
                field_key: 'portFolioName',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              rows: [],
              summary: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },

          {
            table_name: 'Cost Types',
            table_id: 'Cost_Type',
            end_point: '/amazon/costTypeList',
            payload: {
              aggregate: 'CostType',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'CostType',
              data_id: 'CostType',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Cost Types',
                field_key: 'CostType',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },


          {
            table_name: 'Campaign_Name',
            table_id: 'Campaign_Name',
            end_point: '/amazon/campaignNameList',
            payload: {
              aggregate: 'CampaignName',
              start_date: '2023-02-01',
              end_date: '2023-02-15',
              summary: 'Targeting'
            },
            show: 'yes',
            table_json: {
              aggregate: 'CampaignName',
              data_id: 'campaignName',
              search: 'disabled',
              expand_row: 'enable',
              pagination: 'enabled',
              server_pagination: 'enabled',
              trend_chart: 'enable',
              disableIfItemsExist: [ "AudienceName", "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Campaign Name',
                field_key: 'campaignName',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: [],
              isCPC: 1
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            },
            reports: ["campaigns"]
          },

          // ...(selectedProfile && selectedProfile?.amcAvailable == true ? [
            {
              table_name: 'Amc_Audience_Name',
              table_id: 'Amc_Audience_Name',
              end_point: '/amazon/AudienceNameList',
              payload: {
                aggregate: 'AudienceName',
                start_date: '2023-02-01',
                end_date: '2023-02-15',
                summary: 'Targeting'
              },
              show: 'no',
              table_json: {
                aggregate: 'AudienceName',
                data_id: 'AudienceName',
                table_type: 'AmcAudienceName',
                search: 'disabled',
                expand_row: 'enable',
                pagination: 'enabled',
                server_pagination: 'enabled',
                trend_chart: 'disabled',
                disableIfItemsExist: [ "PlacementType", "BiddingStrategy", "AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
                columnSummary: {
                  field_name: 'AMC - Audience Name',
                  field_key: 'AudienceName',
                  field_type: 'any',
                  field_display: '',
                  field_condition: 0,
                  sortParam: null
                },
                summary: [],
                rows: [],
                isCPC: 1
              },
              default_sort: {
                sort_type: 'ASC',
                sort_column: 'Spend',
                is_sort: true
              },
              reports: []
            },
          // ] : []),

          {
            table_name: 'Ad_Group_Name',
            table_id: 'Ad_Group_Name',
            end_point: '/amazon/adGroupNameList',
            payload: {
              aggregate: 'AdGroupName',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'AdGroupName',
              data_id: 'adGroupName',
              search: 'disabled',
              expand_row: 'enable',
              pagination: 'enabled',
              server_pagination: 'enabled',
              trend_chart: 'enable',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Ad Group Name',
                field_key: 'adGroupName',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: [],
              isCPC: 1
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            },
            reports: ["ad_groups"]
          },
          {
            table_name: 'Words by Targeting Keywords',
            table_id: 'TargetingListCount',
            end_point: '/amazon/targetingCountList',
            payload: {
              aggregate: 'TargetingCount',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'word_count',
              data_id: 'word_count',
              trend_chart: 'disable',
              expand_row: 'disabled',
              pagination: 'disabled',
              server_pagination: 'disabled',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Words by Targeting Keywords',
                field_key: 'word_count',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            },
            reports: []
          },
          {
            table_name: 'Targeting',
            table_id: 'Targeting_Text',
            end_point: '/amazon/targetingList',
            payload: {
              aggregate: 'Targeting',
              summary: 'Targeting'
            },
            show: 'yes',
            table_json: {
              aggregate: 'Targeting',
              data_id: 'Targeting',
              trend_chart: 'enable',
              expand_row: 'enable',
              pagination: 'enabled',
              server_pagination: 'enabled',
              isHyperLink: 1,
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Targeting',
                field_key: 'Targeting',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            },
            reports: ["targeting", "keyword"]
          },
          {
            table_name: 'Match Types',
            table_id: 'Match_Type',
            end_point: '/amazon/matchTypeList',
            payload: {
              aggregate: 'MatchType',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'MatchType',
              data_id: 'MatchType',
              trend_chart: 'enable',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Keyword Match Types',
                field_key: 'MatchType',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },
          {
            table_name: 'LookbackPeriod',
            table_id: 'Lookback_period',
            end_point: '/amazon/lookbackPeriodList',
            payload: {
              aggregate: 'LookbackPeriod'
            },
            show: 'no',
            table_json: {
              aggregate: 'LookbackPeriod',
              data_id: 'LookbackPeriod',
              search: 'disabled',
              columnSummary: {
                field_name: 'Lookback Period',
                field_key: 'LookbackPeriod',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: 'no_of_days'
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },
          
        ],

        // SearchTerms

        searchterm: [
          {
            table_name: 'Words by Search term Keywords',
            table_id: 'SearchTermListCount',
            end_point: '/amazon/searchTermCountList',
            payload: {
              aggregate: 'SearchTermCount',
              summary: 'SearchTerm'
            },
            show: 'no',
            table_json: {
              aggregate: 'label_name',
              data_id: 'label_name',
              trend_chart: 'disable',
              expand_row: 'disabled',
              pagination: 'disabled',
              server_pagination: 'disabled',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization", "CampaignType", "TargetingType", "SubTargetingType", "AdFormat", "PortFolioName", "CostType", "MatchType", "CampaignName", "AdGroupName" ],
              columnSummary: {
                field_name: 'Words by Search term Keywords',
                field_key: 'label_name',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            },
            reports: []
          },
          {
            table_name: 'Search Term',
            table_id: 'Search_term',
            end_point: '/amazon/searchTermList',
            payload: {
              aggregate: 'SearchTerm',
              start_date: '2023-02-01',
              end_date: '2023-02-15',
              summary: 'SearchTerm'
            },
            show: 'yes',
            table_json: {
              aggregate: 'SearchTerm',
              data_id: 'SearchTerm',
              pagination: 'enabled',
              server_pagination: 'enabled',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization" ],
              columnSummary: {
                field_name: 'Search Term',
                field_key: 'SearchTerm',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            },
            reports: ["search_term"]
          }
        ],

        placement: [
          {
            table_name: 'Placemenet Types',
            table_id: 'Placement_types',
            end_point: '/amazon/placementTypeList',
            payload: {
              aggregate: 'PlacementType',
              summary: 'Placement'
            },
            show: 'no',
            table_json: {
              aggregate: 'PlacementType',
              data_id: 'PlacementType',
              disableIfItemsExist: [ "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization", "SearchTerm", "CampaignType", "TargetingType", "SubTargetingType", "AdFormat", "PortFolioName", "CostType", "MatchType", "CampaignName", "AdGroupName", "Targeting" ],
              columnSummary: {
                field_name: 'Placement Types',
                field_key: 'PlacementType',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          },
          {
            table_name: 'Bidding Strategy',
            table_id: 'Bidding_Strategy',
            end_point: '/amazon/biddingStrategyList',
            payload: {
              aggregate: 'BiddingStrategy',
              summary: 'Placement'
            },
            show: 'no',
            table_json: {
              aggregate: 'BiddingStrategy',
              data_id: 'BiddingStrategy',
              expand_row: 'enable',
              disableIfItemsExist: ["AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization", "SearchTerm", "CampaignType", "TargetingType", "SubTargetingType", "AdFormat", "PortFolioName", "CostType", "MatchType", "CampaignName", "AdGroupName", "Targeting" ],
              columnSummary: {
                field_name: 'Bidding Strategy',
                field_key: 'BiddingStrategy',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            }
          }
        ],

        // Adv.ASIN

        asin: [
          {
            table_name: 'Advertised ASINs',
            table_id: 'Advertised_ASINs',
            end_point: '/amazon/advertisedASINList',
            payload: {
              aggregate: 'AdvertisedASINs',
              start_date: '2023-02-01',
              end_date: '2023-02-15',
              summary: 'AdvertisedProduct'
            },
            show: 'yes',
            table_json: {
              aggregate: 'AdvertisedASINs',
              data_id: 'AdvertisedASINs',
              expand_row: 'enable',
              pagination: 'enabled',
              product_ads_edit: true,
              server_pagination: 'enabled',
              disableIfItemsExist: [ "PlacementType", "BiddingStrategy", "SearchTerm", "CampaignType", "TargetingType", "SubTargetingType", "AdFormat", "PortFolioName", "CostType", "MatchType", "CampaignName", "AdGroupName", "Targeting" ],
              columnSummary: {
                field_name: 'Advertised ASINs',
                field_key: 'AdvertisedASINs',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: null
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Spend',
              is_sort: true
            },
            reports: ["asin", "advertised_asin"]
          }

        ],

        // PERIOD

        period: [

          {
            table_name: 'Months',
            table_id: 'monthly',
            end_point: '/amazon/monthList',
            payload: {
              aggregate: 'Month',
              start_date: '2023-02-01',
              end_date: '2023-02-15',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'Month',
              data_id: 'Month',
              trend_chart: 'disable',
              columnSummary: {
                field_name: 'Months',
                field_key: 'Month',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: 'FilterField'
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Month',
              is_sort: true
            }
          },

          {
            table_name: 'Weeks',
            table_id: 'weekly',
            end_point: '/amazon/weekList',
            payload: {
              aggregate: 'Week',
              start_date: '2023-02-01',
              end_date: '2023-02-15',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'Week',
              data_id: 'Week',
              trend_chart: 'disable',
              expand_row: 'enable',
              columnSummary: {
                field_name: 'Weeks',
                field_key: 'Week',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: 'FilterField'
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Week',
              is_sort: true
            }
          },

          {
            table_name: 'Date',
            table_id: 'Daily',
            end_point: '/amazon/dayList',
            payload: {
              aggregate: 'Day',
              start_date: '2023-02-01',
              end_date: '2023-02-15',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'Day',
              data_id: 'Day',
              trend_chart: 'disable',
              columnSummary: {
                field_name: 'Date',
                field_key: 'Day',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: 'FilterField'
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'Day',
              is_sort: true
            }
          },

          {
            table_name: 'Weekdays',
            table_id: 'Week_Day',
            end_point: '/amazon/weekdayList',
            payload: {
              aggregate: 'Weekday',
              start_date: '2023-02-01',
              end_date: '2023-02-15',
              summary: 'Targeting'
            },
            show: 'no',
            table_json: {
              aggregate: 'Weekday',
              data_id: 'weekday',
              trend_chart: 'disable',
              columnSummary: {
                field_name: 'Weekdays',
                field_key: 'weekday',
                field_type: 'any',
                field_display: '',
                field_condition: 0,
                sortParam: 'FilterField'
              },
              summary: [],
              rows: []
            },
            default_sort: {
              sort_type: 'ASC',
              sort_column: 'weekday',
              is_sort: true
            }
          },
        ]
      }
    }
  ]
};


export const METRICS_CONSTANT = [
  'IS %',
  'IR',
  'Spend',
  'Total_revenue',
  'Revenue',
  'Organic_revenue',
  'Inventory',
  'Total Orders',
  'Organic Orders',
  'Orders',
  'Impressions',
  'TOS IS %',
  'Clicks',
  'CPA',
  'ROAS',
  'Total ROAS',
  // 'Organic ROAS',
  'Ad ROAS',
  'AOV',
  'CTR %',
  'CPM',
  'CPC',
  'ACOS %',
  'Total ACOS %',
  // 'Organic ACOS %',
  'Ad ACOS %',
  'RPC',
  'CPO',
  'Spend_perc',
  'Revenue_perc',
  'CR_perc',
  'CC',
  'DPV',
  'NTB_Orders',
  'NTB_Orders_Percentage',
  'NTB_Sales',
  'NTB_Sales_Percentage',
  'Viewable_Impressions',
  'Video_First_Quartile',
  'Video_Midpoint',
  'Video_Third_Quartile',
  'Video_Complete',
  'Video_Unmute',
  'VTR',
  'VCTR',
];

export const getCustomTableColumnsTargeting = (heading, displayParam) => {
  return [
    { id: 19, column_type: 'active_view', label: 'Active', param: 'active_status', checked: false, default: 1},
    {
      additionalClass: 'cus_wid col_fixed',
      column_type: 'column_field',
      label: heading,
      param: displayParam,
      field_type: 'any',
      field_display: '',
      checked: true,
      default: 1
    },
    { id: 20, column_type: 'status_view', label: 'Status', param: 'status', checked: false, default: 1 },
    { id: 32, column_type: 'match_type_view', label: 'Match Type', param: 'matchType', checked: false, default: 1 },
    { id: 29, column_type: 'text_view', label: 'Campaign Name', param: 'campaignName', checked: false, default: 1 },
    { id: 30, column_type: 'text_view', label: 'Ad Group Name', param: 'adGroupName', checked: false, default: 1 },
    { id: 31, column_type: 'target_type_view', label: 'Campaign Type', param: 'campaignType', checked: false, default: 1 },
    { id: 19, column_type: 'text_view', label: 'Ad Account', param: 'profileName', checked: true, default: 1 },
    { id: 32, column_type: 'target_acos_view', label: 'Target ACOS %', param: 'Target ACOS %', checked: false, default: 1 },
    { id: 32, column_type: 'percentage', label: 'Best ACOS %', param: 'HECTOR_ACOS', checked: false, default: 1 },  
    { id: 21, column_type: 'sug_bid_view', label: 'Sug. Bid', param: 'sug_bid', checked: false, default: 1 },
    { id: 33, column_type: 'hector_bid_view', label: 'Hector Bid', param: 'Hector Bid', checked: false, default: 1 },
    { id: 22, column_type: 'bid_view', label: 'Current Bid', param: 'bid_amount', checked: false, default: 1 },
    { id: 29, is_based_available: 1, column_type: 'percentage', label: 'IS %', param: 'searchTermImpressionShare', checked: false },
    { id: 30, is_based_available: 1, column_type: 'number', label: 'IR', param: 'searchTermImpressionRank', checked: true },
    // { id: 23, column_type: 'percentage', label: 'TOS IS%', param: 'TOS_IS_perc', checked: true },
    { id: 1, is_based_available: 1, column_type: 'number', label: 'Spend', param: 'Spend', prefix_sign: 'currency', checked: true },
    { id: 2, is_based_available: 1, column_type: 'number', label: 'Revenue', param: 'Revenue', prefix_sign: 'currency', checked: true },
    { id: 3, is_based_available: 1, column_type: 'number', label: 'Orders', param: 'Orders', checked: true },
    { id: 4, is_based_available: 1, column_type: 'number', label: 'Impression', param: 'Impressions', checked: true },
    { id: 5, is_based_available: 1, column_type: 'number', label: 'Clicks', param: 'Clicks', checked: true },
    { id: 6, is_based_available: 1, column_type: 'decimal', label: 'CPA', param: 'CPA', prefix_sign: 'currency', checked: false },
    { id: 7, is_based_available: 1, column_type: 'decimal', label: 'Ad ROAS', param: 'ROAS', checked: true },
    { id: 8, is_based_available: 1, column_type: 'decimal', label: 'AOV', param: 'AOV', prefix_sign: 'currency', checked: true },
    { id: 9, is_based_available: 1, column_type: 'percentage', label: 'CTR %', param: 'CTR', checked: true },
    { id: 10, is_based_available: 1, column_type: 'decimal', label: 'CPM', param: 'CPM', checked: true },
    { id: 11, is_based_available: 1, column_type: 'decimal', label: 'CPC', param: 'CPC', checked: true },
    { id: 12, is_based_available: 1, column_type: 'percentage', label: 'Ad ACOS %', param: 'ACOS', checked: true },
    { id: 13, is_based_available: 1, column_type: 'number', label: 'RPC', param: 'RPC', checked: false },
    { id: 14, is_based_available: 1, column_type: 'number', label: 'CPO', param: 'CPO', checked: false },
    { id: 15, is_based_available: 1, column_type: 'percentage', label: 'Spend %', param: 'Spend_perc', checked: true },
    { id: 16, is_based_available: 1, column_type: 'percentage', label: 'Rev %', param: 'Revenue_perc', checked: true },
    { id: 17, is_based_available: 1, column_type: 'percentage', label: 'CR %', param: 'CR_perc', checked: true },
    { id: 18, is_based_available: 1, column_type: 'number', label: 'CC', param: 'CC', checked: true },
    { id: 19, is_based_available: 1, column_type: 'comparison', label: 'Compare', param: 'Compare', checked: false, isLast: 1, isUngroup: true }
  ]
};

export const getAsinCustomDetails = [
  { id: 19, column_type: 'active_view', label: 'Active', param: 'active_status', checked: true, default: 1 },
  {
    // additionalClass: 'cus_wid col_fixed',
    column_type: 'image_view',
    label: 'Advertised ASINs',
    param: 'AdvertisedASINs',
    field_type: 'any',
    field_display: '',
    checked: true,
    default: 1
  },
  { id: 29, column_type: 'text_view', label: 'Campaign Name', param: 'campaignName', checked: false, default: 1 },
  { id: 30, column_type: 'text_view', label: 'Ad Group Name', param: 'adGroupName', checked: false, default: 1 },
  { id: 31, column_type: 'target_type_view', label: 'Campaign Type', param: 'Type', checked: false, default: 1 },
  { id: 29, column_type: 'text_view', label: 'Ad Account', param: 'profileName', checked: true, default: 1 },
  // { id: 36, column_type: 'bsr_rank', additionalClass: 'bsr_column', label: 'BSR Rank', param: 'BSR_Orders', checked: true, default: 1 },
  // { id: 32, column_type: 'number', label: 'Total Revenue', param: 'Total_revenue', checked: true, default: 1 },
  // { id: 33, column_type: 'number', label: 'Organic Revenue', param: 'Organic_revenue', checked: true, default: 1 },
  // { id: 34, column_type: 'number', label: 'Inventory', param: 'Inventory', checked: true, default: 1 },
  { id: 1, is_based_available: 1, column_type: 'number', label: 'Spend', param: 'Spend', prefix_sign: 'currency', checked: true },
  // { id: 2, is_based_available: 1, column_type: 'number', label: 'Total Revenue', param: 'Total_revenue', prefix_sign: 'currency', checked: true },
  { id: 2, is_based_available: 1, column_type: 'number', label: 'Revenue', param: 'Revenue', prefix_sign: 'currency', checked: true },
  // { id: 2, is_based_available: 1, column_type: 'number', label: 'Organic Revenue', param: 'Organic_revenue', prefix_sign: 'currency', checked: true },
  { id: 3, is_based_available: 1, column_type: 'number', label: 'Orders', param: 'Orders', checked: true },
  { id: 4, is_based_available: 1, column_type: 'number', label: 'Impression', param: 'Impressions', checked: true },
  { id: 5, is_based_available: 1, column_type: 'number', label: 'Clicks', param: 'Clicks', checked: true },
  { id: 6, is_based_available: 1, column_type: 'decimal', label: 'CPA', param: 'CPA', prefix_sign: 'currency', checked: false },
  { id: 7, is_based_available: 1, column_type: 'decimal', label: 'Ad ROAS', param: 'ROAS', checked: true },
  { id: 8, is_based_available: 1, column_type: 'decimal', label: 'AOV', param: 'AOV', prefix_sign: 'currency', checked: true },
  { id: 9, is_based_available: 1, column_type: 'percentage', label: 'CTR %', param: 'CTR', checked: true },
  { id: 10, is_based_available: 1, column_type: 'decimal', label: 'CPM', param: 'CPM', checked: true },
  { id: 11, is_based_available: 1, column_type: 'decimal', label: 'CPC', param: 'CPC', checked: true },
  { id: 12, is_based_available: 1, column_type: 'percentage', label: 'Ad ACOS %', param: 'ACOS', checked: true },
  { id: 13, is_based_available: 1, column_type: 'number', label: 'RPC', param: 'RPC', checked: false },
  { id: 14, is_based_available: 1, column_type: 'number', label: 'CPO', param: 'CPO', checked: false },
  { id: 15, is_based_available: 1, column_type: 'percentage', label: 'Spend %', param: 'Spend_perc', checked: true },
  { id: 16, is_based_available: 1, column_type: 'percentage', label: 'Rev %', param: 'Revenue_perc', checked: true },
  { id: 17, is_based_available: 1, column_type: 'percentage', label: 'CR %', param: 'CR_perc', checked: true },
  { id: 18, is_based_available: 1, column_type: 'number', label: 'CC', param: 'CC', checked: true },
];

export const getAudienceNameCustomDetails = [
  {
    // additionalClass: 'cus_wid col_fixed',
    column_type: 'column_field',
    label: 'AMC - Audience Name',
    param: 'AudienceName',
    field_type: 'any',
    field_display: '',
    checked: true,
    default: 1
  },
  { id: 29, column_type: 'text_view', label: 'Campaign Name', param: 'campaignName', checked: false, default: 1 },
 { id: 30,  column_type: 'audience_status_view', label: 'Status', param: 'AudienceStatus', checked: false, default: 1 },
 { id: 31, column_type: 'audience_bid_view', label: 'Bid Adjustment', param: 'currentPercentage', checked: false, default: 1 },
  // { id: 30, column_type: 'text_view', label: 'Ad Group Name', param: 'adGroupName', checked: false, default: 1 },
  // { id: 31, column_type: 'target_type_view', label: 'Campaign Type', param: 'Type', checked: false, default: 1 },
  // { id: 29, column_type: 'text_view', label: 'Ad Account', param: 'profileName', checked: true, default: 1 },
  // { id: 36, column_type: 'bsr_rank', additionalClass: 'bsr_column', label: 'BSR Rank', param: 'BSR_Orders', checked: true, default: 1 },
  // { id: 32, column_type: 'number', label: 'Total Revenue', param: 'Total_revenue', checked: true, default: 1 },
  // { id: 33, column_type: 'number', label: 'Organic Revenue', param: 'Organic_revenue', checked: true, default: 1 },
  // { id: 34, column_type: 'number', label: 'Inventory', param: 'Inventory', checked: true, default: 1 },
  { id: 1, is_based_available: 1, column_type: 'number', label: 'Spend', param: 'Spend', prefix_sign: 'currency', checked: true },
  // { id: 2, is_based_available: 1, column_type: 'number', label: 'Total Revenue', param: 'Total_revenue', prefix_sign: 'currency', checked: true },
  { id: 2, is_based_available: 1, column_type: 'number', label: 'Revenue', param: 'Revenue', prefix_sign: 'currency', checked: true },
  // { id: 2, is_based_available: 1, column_type: 'number', label: 'Organic Revenue', param: 'Organic_revenue', prefix_sign: 'currency', checked: true },
  { id: 3, is_based_available: 1, column_type: 'number', label: 'Orders', param: 'Orders', checked: true },
  { id: 4, is_based_available: 1, column_type: 'number', label: 'Impression', param: 'Impressions', checked: true },
  { id: 5, is_based_available: 1, column_type: 'number', label: 'Clicks', param: 'Clicks', checked: true },
  { id: 6, is_based_available: 1, column_type: 'decimal', label: 'CPA', param: 'CPA', prefix_sign: 'currency', checked: false },
  { id: 7, is_based_available: 1, column_type: 'decimal', label: 'Ad ROAS', param: 'ROAS', checked: true },
  { id: 8, is_based_available: 1, column_type: 'decimal', label: 'AOV', param: 'AOV', prefix_sign: 'currency', checked: true },
  { id: 9, is_based_available: 1, column_type: 'percentage', label: 'CTR %', param: 'CTR', checked: true },
  { id: 10, is_based_available: 1, column_type: 'decimal', label: 'CPM', param: 'CPM', checked: true },
  { id: 11, is_based_available: 1, column_type: 'decimal', label: 'CPC', param: 'CPC', checked: true },
  { id: 12, is_based_available: 1, column_type: 'percentage', label: 'Ad ACOS %', param: 'ACOS', checked: true },
  { id: 13, is_based_available: 1, column_type: 'number', label: 'RPC', param: 'RPC', checked: false },
  { id: 14, is_based_available: 1, column_type: 'number', label: 'CPO', param: 'CPO', checked: false },
  { id: 15, is_based_available: 1, column_type: 'percentage', label: 'Spend %', param: 'Spend_perc', checked: true },
  { id: 16, is_based_available: 1, column_type: 'percentage', label: 'Rev %', param: 'Revenue_perc', checked: true },
  { id: 17, is_based_available: 1, column_type: 'percentage', label: 'CR %', param: 'CR_perc', checked: true },
  { id: 18, is_based_available: 1, column_type: 'number', label: 'CC', param: 'CC', checked: true },
];

export const TARGETING_TEXT_OWN_CONSTANT_AUTO = [
  {
    table_name: 'Targeting',
    table_id: 'Targeting',
    end_point: '/amazon/targetingDetailsList',
    payload: {
      aggregate: 'Targeting',
      summary: 'Targeting'
    },
    show: 'no',
    table_json: {
      aggregate: 'Targeting',
      data_id: 'keywordId',
      trend_chart: 'disable',
      expand_row: 'enable',
      pagination: 'enabled',
      server_pagination: 'enabled',
      isHyperLink: 0,
      columns: getCustomTableColumnsTargeting('Targeting', 'Targeting'),
      columnSummary: {
        field_name: 'Targeting',
        field_key: 'Targeting',
        field_type: 'any',
        field_display: '',
        field_condition: 0,
        sortParam: null
      },
      summary: [],
      rows: [],
      isCPC: 1,
    },
    default_sort: {
      sort_type: 'ASC',
      sort_column: 'Spend',
      is_sort: true
    }
  }
];

export const TARGETING_TEXT_OWN_CONSTANT_NON_AUTO = [
  {
    table_name: 'Targeting',
    table_id: 'Targeting',
    end_point: '/amazon/targetingDetailsList',
    payload: {
      aggregate: 'Targeting',
      summary: 'Targeting'
    },
    show: 'no',
    table_json: {
      aggregate: 'Targeting',
      data_id: 'keywordId',
      trend_chart: 'disable',
      expand_row: 'enable',
      pagination: 'enabled',
      server_pagination: 'enabled',
      isHyperLink: 0,
      columns: getCustomTableColumnsTargeting('Keyword', 'keywordText'),
      columnSummary: {
        field_name: 'Keyword',
        field_key: 'keywordText',
        field_type: 'any',
        field_display: '',
        field_condition: 0,
        sortParam: null
      },
      summary: [],
      rows: [],
      isCPC: 1,
    },
    default_sort: {
      sort_type: 'ASC',
      sort_column: 'Spend',
      is_sort: true
    }
  }
];

export const getSearchTermColumns = [
  {
    column_type: 'column_field',
    label: 'Search Term',
    param: 'SearchTerm',
    field_type: 'any',
    field_display: '',
    checked: true,
    default: 1
  },
  { id: 29, column_type: 'text_view', label: 'Campaign Name', param: 'campaignName', checked: false, default: 1 },
  { id: 30, column_type: 'text_view', label: 'Ad Group Name', param: 'adGroupName', checked: false, default: 1 },
  { id: 31, column_type: 'target_type_view', label: 'Campaign Type', param: 'Type', checked: false, default: 1 },
  { id: 28, column_type: 'text_view', label: 'Ad Account', param: 'profileName', checked: true, default: 1 },
  { id: 99, column_type: 'text_view', label: 'Target Name', param: 'targetName', checked: true, default: 1 },
  { id: 29, is_based_available: 1, column_type: 'percentage', label: 'IS %', param: 'searchTermImpressionShare', checked: false },
  { id: 30, is_based_available: 1, column_type: 'number', label: 'IR', param: 'searchTermImpressionRank', checked: true },
  // { id: 31, column_type: 'text_view', label: 'Match Type', param: 'matchType', checked: true, default: 1 },
  // { id: 25, is_based_available: 1, column_type: 'percentage', label: 'IS %', param: 'IS_perc', checked: true, default: 1 }, //  Hidden per Hariom Comment in the hector plus whatsapp group
  // { id: 25, is_based_available: 1, column_type: 'number', label: 'ST Rank', param: 'search_term_impression_rank', checked: true, default: 1 },  //  Hidden per Hariom Comment in the hector plus whatsapp group
  { id: 1, is_based_available: 1, column_type: 'number', label: 'Spend', param: 'Spend', prefix_sign: 'currency', checked: true },
  { id: 2, is_based_available: 1, column_type: 'number', label: 'Revenue', param: 'Revenue', prefix_sign: 'currency', checked: true },
  { id: 3, is_based_available: 1, column_type: 'number', label: 'Orders', param: 'Orders', checked: true },
  { id: 4, is_based_available: 1, column_type: 'number', label: 'Impression', param: 'Impressions', checked: true },
  { id: 5, is_based_available: 1, column_type: 'number', label: 'Clicks', param: 'Clicks', checked: true },
  { id: 6, is_based_available: 1, column_type: 'decimal', label: 'CPA', param: 'CPA', prefix_sign: 'currency', checked: false },
  { id: 7, is_based_available: 1, column_type: 'decimal', label: 'Ad ROAS', param: 'ROAS', checked: true },
  { id: 8, is_based_available: 1, column_type: 'decimal', label: 'AOV', param: 'AOV', prefix_sign: 'currency', checked: true },
  { id: 9, is_based_available: 1, column_type: 'percentage', label: 'CTR %', param: 'CTR', checked: false },  { id: 10, is_based_available: 1, column_type: 'decimal', label: 'CPM', param: 'CPM', checked: true },
  { id: 11, is_based_available: 1, column_type: 'decimal', label: 'CPC', param: 'CPC', checked: true },
  { id: 12, is_based_available: 1, column_type: 'percentage', label: 'Ad ACOS %', param: 'ACOS', checked: true },
  { id: 13, is_based_available: 1, column_type: 'number', label: 'RPC', param: 'RPC', checked: false },
  { id: 14, is_based_available: 1, column_type: 'number', label: 'CPO', param: 'CPO', checked: false },
  { id: 15, is_based_available: 1, column_type: 'percentage', label: 'Spend %', param: 'Spend_perc', checked: true },
  { id: 16, is_based_available: 1, column_type: 'percentage', label: 'Rev %', param: 'Revenue_perc', checked: true },
  { id: 17, is_based_available: 1, column_type: 'percentage', label: 'CR %', param: 'CR_perc', checked: true },
  { id: 18, is_based_available: 1, column_type: 'number', label: 'CC', param: 'CC', checked: true },
  // { id: 19, is_based_available: 1, column_type: 'comparison', label: 'Compare', param: 'Compare', checked: false, isLast: 1, isUngroup: true }
];

export const getAudienceNameColumns = [
  {
    column_type: 'column_field',
    label: 'Audience Name',
    param: 'AudienceName',
    field_type: 'any',
    field_display: '',
    checked: true,
    default: 1
  },
  { id: 29, column_type: 'text_view', label: 'Campaign Name', param: 'campaignName', checked: false, default: 1 },
  { id: 20, is_based_available: 1, column_type: 'audience_status_view', label: 'Status', param: 'AudienceStatus', checked: true },
  { id: 21, is_based_available: 1, column_type: 'audience_bid_view', label: 'Bid Adjustment', param: 'currentPercentage', checked: true },
  { id: 1, is_based_available: 1, column_type: 'number', label: 'Spend', param: 'Spend', prefix_sign: 'currency', checked: true },
  { id: 2, is_based_available: 1, column_type: 'number', label: 'Revenue', param: 'Revenue', prefix_sign: 'currency', checked: true },
  { id: 3, is_based_available: 1, column_type: 'number', label: 'Orders', param: 'Orders', checked: true },
  { id: 4, is_based_available: 1, column_type: 'number', label: 'Impression', param: 'Impressions', checked: true },
  { id: 5, is_based_available: 1, column_type: 'number', label: 'Clicks', param: 'Clicks', checked: true },
  { id: 6, is_based_available: 1, column_type: 'decimal', label: 'CPA', param: 'CPA', prefix_sign: 'currency', checked: false },
  { id: 7, is_based_available: 1, column_type: 'decimal', label: 'Ad ROAS', param: 'ROAS', checked: true },
  { id: 8, is_based_available: 1, column_type: 'decimal', label: 'AOV', param: 'AOV', prefix_sign: 'currency', checked: true },
  { id: 9, is_based_available: 1, column_type: 'percentage', label: 'CTR %', param: 'CTR', checked: false },  { id: 10, is_based_available: 1, column_type: 'decimal', label: 'CPM', param: 'CPM', checked: true },
  { id: 11, is_based_available: 1, column_type: 'decimal', label: 'CPC', param: 'CPC', checked: true },
  { id: 12, is_based_available: 1, column_type: 'percentage', label: 'Ad ACOS %', param: 'ACOS', checked: true },
  { id: 13, is_based_available: 1, column_type: 'number', label: 'RPC', param: 'RPC', checked: false },
  { id: 14, is_based_available: 1, column_type: 'number', label: 'CPO', param: 'CPO', checked: false },
  { id: 15, is_based_available: 1, column_type: 'percentage', label: 'Spend %', param: 'Spend_perc', checked: true },
  // { id: 16, is_based_available: 1, column_type: 'percentage', label: 'Rev %', param: 'Revenue_perc', checked: true },
  { id: 17, is_based_available: 1, column_type: 'percentage', label: 'CR %', param: 'CR_perc', checked: true },
  { id: 18, is_based_available: 1, column_type: 'number', label: 'CC', param: 'CC', checked: true },
  { id: 19, is_based_available: 1, column_type: 'comparison', label: 'Compare', param: 'Compare', checked: false, isLast: 1, isUngroup: true }
];

export const getAdGroupNameColumns = [
  {
    column_type: 'column_field',
    label: 'Audience Name',
    param: 'audienceResolved',
    field_type: 'any',
    field_display: '',
    checked: true,
    default: 1
  },
  // { id: 29, column_type: 'text_view', label: 'Campaign Name', param: 'campaignName', checked: false, default: 1 },
  { id: 1, is_based_available: 1, column_type: 'audience_sd_status_view', label: 'Status', param: 'audienceStatus', checked: true },
  { id: 2, is_based_available: 1, column_type: 'number', label: 'Size', param: 'audienceSize', checked: true },
  // { id: 3, is_based_available: 1, column_type: 'start_date_view', label: 'Start Date', param: 'startDate', checked: true },
  { id: 4, is_based_available: 1, column_type: 'text_view', label: 'Update Audience', param: 'updateAudience', checked: true },
  { id: 5, is_based_available: 1, column_type: 'audience_bid_view', label: 'Bid Adjustment', param: 'bidValue', checked: true }
];

export const SEARCH_TERM_CONSTANT = [
  {
    table_name: 'Search Term',
    table_id: 'Search_term',
    end_point: '/amazon/searchTermList',
    payload: {
      aggregate: 'SearchTerm',
      start_date: '2023-02-01',
      end_date: '2023-02-15',
      summary: 'SearchTerm'
    },
    show: 'no',
    table_json: {
      aggregate: 'SearchTerm',
      data_id: 'SearchTerm',
      pagination: 'enabled',
      server_pagination: 'enabled',
      disableIfItemsExist: [ "PlacementType", "BiddingStrategy","AdvertisedASINs", "BrandCategorization", "CategoryCategorization", "SubCategoryCategorization", "CampaignType", "TargetingType", "SubTargetingType", "AdFormat", "PortFolioName", "CostType", "MatchType", "CampaignName", "AdGroupName" ],
      columnSummary: {
        field_name: 'Search Term',
        field_key: 'SearchTerm',
        field_type: 'any',
        field_display: '',
        field_condition: 0,
        sortParam: null
      },
      summary: [],
      rows: []
    },
    default_sort: {
      sort_type: 'ASC',
      sort_column: 'Spend',
      is_sort: true
    },
    reports: ["search_term"]
  }
]

export const SEARCH_TERM_DETAILS_CONSTANT = [
  {
    table_name: 'Search Term',
    table_id: 'Search_term_modal',
    end_point: '/amazon/searchTermDetailsList',
    payload: {
      aggregate: 'SearchTerm',
      summary: 'SearchTerm'
    },
    show: 'no',
    table_json: {
      aggregate: 'SearchTerm',
      data_id: 'SearchTerm',
      pagination: 'enabled',
      server_pagination: 'enabled',
      disableIfItemsExist: [],
      columns: getSearchTermColumns,
      columnSummary: {
        field_name: 'Search Term',
        field_key: 'SearchTerm',
        field_type: 'any',
        field_display: '',
        field_condition: 0,
        sortParam: null
      },
      summary: [],
      rows: []
    },
    default_sort: {
      sort_type: 'ASC',
      sort_column: 'Spend',
      is_sort: true
    },
    reports: ["search_term"]
  }
]

export const AUDIENCE_NAME_DETAILS_CONSTANT = [
  {
    table_name: 'Audience Name',
    table_id: 'Audience_name',
    end_point: '/amazon/AudienceNameBreakUp',
    payload: {
      aggregate: 'AudienceName',
      summary: 'AudienceName'
    },
    show: 'no',
    table_json: {
      aggregate: 'AudienceName',
      data_id: 'AudienceName',
      table_type: 'AudienceNameDetails',
      pagination: 'enabled',
      server_pagination: 'enabled',
      disableIfItemsExist: [],
      columns: getAudienceNameColumns,
      columnSummary: {
        field_name: 'Audience Name',
        field_key: 'AudienceName',
        field_type: 'any',
        field_display: '',
        field_condition: 0,
        sortParam: null
      },
      summary: [],
      rows: []
    },
    default_sort: {
      sort_type: 'ASC',
      sort_column: 'Spend',
      is_sort: true
    },
    reports: ["audience_name"]
  }
]

export const ADGROUP_NAME_DETAILS_CONSTANT = [
  {
    table_name: 'Adgroup Name',
    table_id: 'Adgroup_name',
    end_point: '/amc/findExistingAudienceInGroup',
    payload: {
      aggregate: 'AdGroupName_Audience',
      summary: 'AdGroupName'
    },
    show: 'no',
    table_json: {
      aggregate: 'AdGroupName_Audience',
      data_id: 'AdGroupName',
      table_type: 'AdGroupNameDetails',
      pagination: 'enabled',
      server_pagination: 'enabled',
      disableIfItemsExist: [],
      columns: getAdGroupNameColumns,
      columnSummary: {
        field_name: 'Audience Name',
        field_key: 'AdGroupName',
        field_type: 'any',
        field_display: '',
        field_condition: 0,
        sortParam: null
      },
      summary: [],
      rows: []
    },
    default_sort: {
      sort_type: 'ASC',
      sort_column: 'Spend',
      is_sort: true
    },
    reports: ["audience_name"]
  }
]

export const ASIN_DETAILS_CONSTANT = [
  {
    table_name: 'Advertised ASINs',
    table_id: 'Advertised_ASINs',
    end_point: '/amazon/advertisedASINDetailsList',
    payload: {
      aggregate: 'AdvertisedASINs',
      start_date: '2023-02-01',
      end_date: '2023-02-15',
      summary: 'AdvertisedProduct'
    },
    show: 'no',
    table_json: {
      aggregate: 'AdvertisedASINs',
      data_id: 'adId',
      expand_row: 'enable',
      pagination: 'disabled',
      server_pagination: 'disabled',
      product_ads_edit: false,
      disableIfItemsExist: [ "PlacementType", "BiddingStrategy", "SearchTerm", "CampaignType", "TargetingType", "SubTargetingType", "AdFormat", "PortFolioName", "CostType", "MatchType", "CampaignName", "AdGroupName", "Targeting" ],
      columns: getAsinCustomDetails,
      columnSummary: {
        field_name: 'Advertised ASINs',
        field_key: 'AdvertisedASINs',
        field_type: 'any',
        field_display: '',
        field_condition: 0,
        sortParam: null
      },
      summary: [],
      rows: [],
      isCPC: 1,
    },
    default_sort: {
      sort_type: 'ASC',
      sort_column: 'Spend',
      is_sort: true
    }
  }
];

export const MODALS_TYPES = {
  add_to_negative_same_ad_group: 'Add the keyword as Negative in same Ad Group',
  add_to_negative_existing_campaign: 'Add to negative in the existing campaign',
  add_to_blacklist: 'Add the keyword in the Blacklist'
};

export const DEFAULT_SORT_CONFIG = { sort_type: '', sort_column: '', is_sort: false };

export const CALENDAR_OPTIONS = [
  { label: 'Yesterday' },
  { label: 'This Month' },
  { label: 'Last Month' },
  { label: 'Last 30 Days' },
  { label: 'This Year' },
  { label: 'Last 7 Days' },
  { label: 'Last 7 Weeks' },
  { label: 'Last 7 Months' },
  { label: 'Last 7 Weekdays' },
  { label: 'Last 7 Weekends' },
  { label: 'Last 7 Same day' }
];

export const UNGROUP_CHK_PROP = {
  Targeting: [
      'matchType',
      'campaignName',
      'adGroupName',
      'campaignType'
  ],
  ...(window.location.href.includes('/flipkart') ? {
    SearchTerm: [
      'campaign_name',
      'adgroup_name',
      'SearchTerm'
    ]
  } : {
    SearchTerm: [
      'campaignName',
      'adGroupName',
      'Type'
    ],
  }),
  
  AdvertisedASINs: [
      'campaignName',
      'campaignId',
      'adGroupName',
      'adGroupId',
      'Type'
  ],
  AudienceName: [
    'AudienceName',
    'campaignName',
    'campaignId',
  ],
  AdGroupName_Audience: [
    'audienceId',
    'targetId',
  ],
  productId: [
    'AdGroupId',
    'AdGroupName',
    'CampaignId',
    'CampaignName',
  ],
  Campaigns: [
    'Campaign',
    'CampaignId',
  ],
  AdGroup: [
    'Campaign',
    'AdGroup',
    'AdGroupId',
    'CampaignId',
  ],
  FsnId: ['FsnId', 'campaign_name', 'adgroup_name', 'banner_id'],
  Placement: [
    'Campaign',
    'AdGroup',
    'AdGroupId',
    'CampaignId',
  ]
}
export const INVERSE_METRICS = ['CPC', 'CPM', 'CPO', 'ACOS', 'CPA']

export default AMAZON_TAB_GROUP;
